module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02aea15d!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-02aea15d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Modal.vue
// module chunks = 0